var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cf9f66;}.cls-2{fill:#89643d;}.cls-3{fill:#c45c00;}.cls-4{fill:#c98019;}.cls-5{fill:#eb9800;}.cls-6{fill:#d68b00;}.cls-7{fill:#ebba1d;}.cls-8{fill:#ffca1f;}.cls-9{fill:#ffd85e;}.cls-10{fill:#ffe38a;}.cls-11{fill:#d96600;}.cls-12{fill:#ffd03b;}.cls-13{fill:#ffe38c;}.cls-14{fill:#fff4d1;}.cls-15{fill:#fff0c2;}.cls-16,.cls-29{fill:#fff276;}.cls-16{opacity:0.51;}.cls-17{fill:#fff2ff;}.cls-18{fill:#965030;}.cls-19{fill:#ffb95c;}.cls-20{fill:#ffe9cc;}.cls-21{fill:url(#linear-gradient);}.cls-22{fill:#ff9100;opacity:0.47;}.cls-23{fill:#70270f;}.cls-24{fill:url(#linear-gradient-2);}.cls-25{fill:url(#linear-gradient-3);}.cls-26{fill:#fff0db;}.cls-27{fill:#ffbc00;}.cls-28{fill:#fff8f0;}.cls-29{opacity:0.24;}.cls-30{fill:#fff8ed;}.cls-31{fill:#fff;}.cls-32{fill:#351207;}.cls-33{fill:#4a190a;}.cls-34{fill:#6b240e;}.cls-35{fill:#009c08;}.cls-36{fill:#00c40a;}.cls-37{fill:#1cff28;}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: 15.621,
    x2: 22.602,
    y1: 20.979,
    y2: 31.338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#ffd59e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#ffb76c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-0.503, -0.864, 0.864, -0.503, 23.33, 50.29)",
    id: "linear-gradient-2",
    x1: 22.787,
    x2: 29.768,
    xlinkHref: "#linear-gradient",
    y1: 13.562,
    y2: 23.921
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(20.393 -19.201) rotate(41.62)",
    id: "linear-gradient-3",
    x1: 32.123,
    x2: 39.104,
    xlinkHref: "#linear-gradient",
    y1: 12.352,
    y2: 22.711
  }))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ramen"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32.513,
    cy: 32.048,
    r: 27.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32.564,
    cy: 32.099,
    r: 23.384
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 29.867,
    cy: 30.521,
    r: 18.486
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.048,25.982s5.092-4.6,10.606-3.632,6.336,6.4,4.1,8.469c0,0-.73-.088-1.117-1.291s-1.583-3.808-3.955-3.8-4.907.382-10.092,4.524A10.781,10.781,0,0,1,10.048,25.982Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.327,20.646s7.257-4.77,11.971.346a25.613,25.613,0,0,0,3.374,4.756c1.391,1.236,4.9,2.294,4.7,6.576s-2.194,5.7-3.312,5.8S38.607,37.3,37.179,39.3s-.754,6.863-2.57,9.132-10.319-.936-7.86-7.2-1.738-9.774-2.522-11.45S21.383,23.91,27,21.944s4.363,2.149,2.88,2.641-4.327.819-3.781,3.809,4.176,4.34,3.924,8.7S27.97,42.57,28.828,44.3s3.783,3.343,4.409,1.444S33.113,38.3,36.9,36.067s7.908.288,9.12-.908,1.03-4.262-1.409-5.98a18.5,18.5,0,0,1-5.326-6.258c-1.2-2.161-5.432-2.121-9.1.082S26,22.653,29.327,20.646Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.691,18.271s-2.884-3.59.218-7.007,12.915-.922,11.986,4.458.237,5.205,1.7,6.173,4.016.764,5.967,1.949,3.589,3.636.925,7.028A8.658,8.658,0,0,1,36.4,33.32c-4.216-2.053-7.262-3.648-9.359,1.907s-3.152,9.694-6.265,9.948-3.847-.862-2.612-2.253,2.6.039,3.814-1.79,1.176-4.48,3.91-8.456,6.556-3.551,10.335-1.472a6.015,6.015,0,0,0,8.385-2.025c1.549-2.341,1.008-4.067-5.393-4.725,0,0-4.505-1.3-3.791-5.557s-.51-6.543-3.186-6.63-4.858,2.1-3.628,6.04S26.691,18.271,26.691,18.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47.593,26.1s1.149-5.235-3.289-8.065-8.436,1.782-10.488,6S33.553,32.065,31,33.85s-7.032-.34-9.8.035-9.665,4.755-.9,12.338,19.119-.92,20.474-2.969,1.784-4.288,3.555-5.851-1.613-2.014-2.485-1.013a22.877,22.877,0,0,0-3.1,5c-.966,2.1-6.139,4.669-9.861,4.731s-8.862-1.866-9.559-6.218,5.61-2.915,7-2.312S36,36.946,36,29.794s4.393-9.5,7.339-9.028,1.87,6.075,1.022,6.881-4.511,3.957-9.2.228l-.891,2.46s3.932,4.073,8.159,2.452S47.593,26.1,47.593,26.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22.531,31.794s-6.129-4.448-1.19-11.2S35.425,14.925,36,17.988s-1.585,5.973,1,9.813,7.858,3.384,10.1,9.051-7.2,12.67-13.092,7.272-.982-9.01.6-9.855,2.228.685,1.357,2-4.62,4.122.682,7.077,10.607-3.395,7.421-6.686-3.967-1.993-7.96-6.212-2.437-8-2.424-9.57-1.857-3.99-5.082-2.573-10.575,7.282-3.675,13.187C24.938,31.494,25.143,32.734,22.531,31.794Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.728,25.633S42.414,21.982,38.3,29.149s8.41,11.453,9.274,8.238-.275-1.969-1.806-1.721-7,.415-6.053-5.476c.825-5.107,7.121-4.145,8.516-2.878a.835.835,0,0,0,1.317-.179C49.731,26.767,49.622,26.268,48.728,25.633Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M32.9,39.745s4.134-2.314,3.537-5.943-1.2-2.842-1.1-2.149,1.014,3.117-.366,4.965a8.331,8.331,0,0,1-2.636,2.673C30.894,40.391,32.607,39.947,32.9,39.745Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.555,16.139s3.228-.467,3.947,1.665.277.893-.711.24S29.477,16.9,31.555,16.139Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 36.713,
    cy: 36.119,
    r: 16.327
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.722,52.191s2.891-5.326.918-9.859-6.809-4.111-8.122-1.762c0,0,.228.609,1.341.692s3.6.569,4.082,2.607.69,4.291-1.79,9.6A9.521,9.521,0,0,0,44.722,52.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.3,34.533s2.589-7.219-2.782-10.2a22.646,22.646,0,0,1-4.783-1.91c-1.349-.938-2.985-3.729-6.619-2.666S26.68,22.819,26.825,23.8s2.254,6.223.833,7.864-5.735,2.071-7.306,4.1,2.944,8.664,7.809,5.254,8.751-.536,10.352-.21,5.636,1.221,6.159-4.006-2.75-3.3-2.865-1.924.2,3.885-2.485,4.037-4.592-2.685-8.279-1.565-4.28,2.9-5.938,2.518-3.656-2.554-2.155-3.485,6.416-1.438,7.543-5.152S28.605,24.5,29.38,23.215s3.445-1.769,5.426-.032a16.322,16.322,0,0,0,6.477,3.273c2.1.582,2.948,4.224,1.818,7.828S44.27,37.805,45.3,34.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47.888,36.3a4.789,4.789,0,0,0,5.97-1.641c2.29-3.372-1.888-11.278-6.313-9.364s-4.518.876-5.653-.179S40.4,21.829,38.981,20.4s-3.867-2.327-6.225.663a7.648,7.648,0,0,0,.2,10.024c2.637,3.194,4.639,5.478.3,8.431s-7.667,4.717-7.24,7.442,1.538,3.124,2.476,1.775-.574-2.227.745-3.645,3.6-1.939,6.448-5.112,1.688-6.365-.88-9.177a5.313,5.313,0,0,1,0-7.619c1.688-1.815,3.282-1.709,5.175,3.649,0,0,2.049,3.6,5.557,2.1s5.723-.92,6.353,1.359S51.1,34.9,47.459,34.661,47.888,36.3,47.888,36.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M36.828,19.985s4.255-2.072,7.606,1.15.221,7.611-2.973,10.248-6.838,1.892-7.842,4.45,1.751,5.966,2,8.424-2.075,9.284-10.4,3.336-3.177-16.6-1.7-18.191,3.311-2.422,4.286-4.267,2.063.967,1.385,1.924a20.246,20.246,0,0,1-3.649,3.7c-1.6,1.263-2.734,6.238-2.015,9.446s3.441,7.22,7.321,6.916,1.339-5.421.533-6.488-1.457-8.443,4.684-9.926,7.247-5.744,6.227-8.174-5.6-.345-6.119.55-2.462,4.694,1.712,7.941L35.958,32.3s-4.312-2.53-3.8-6.5S36.828,19.985,36.828,19.985Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M37.142,42.681s5.091,4.338,9.861-1.3,1.945-13.267-.8-13.126-4.8,2.6-8.632,1.176-4.535-6.044-9.866-6.8S18.318,31.44,24.175,35.38s7.938-1.027,8.335-2.563-1.051-1.771-2-.75-2.58,4.822-6.217.883.714-9.81,4.2-7.757,2.534,2.991,6.984,5.544,7.374.432,8.719.1,3.81.767,3.263,3.829S43.4,45.25,36.9,40.552C36.9,40.552,35.794,40.633,37.142,42.681Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M54.337,39.551a8.635,8.635,0,0,1-3.97-2.9c-2.145-2.471-4.952-5.083-10.617-2.576s-4.855,8.974-.564,11.7c0,0,1.411.36-.132-1.393s-3.055-4.905-.1-7.232,5.749-2.428,8.211-.3,3.621,4.638,6.522,5.273A8.927,8.927,0,0,0,54.337,39.551Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.447,50.643s7.495-1.915,7.2-11.319c0,0-.549-4.954-6.033-4.263s-7.514-.879-9.267-2.747-5.256-3.222-8.607.722.053,16.237,8.652,14.158.394,5.207-.968,5.051-1.949-.464-3.943-2.16-6.295-6.966-11.253-6.5c0,0-.438.386.887,1.777s2.856-.6,7.672,4.121,6.481,6.425,11.918,1.007.2-5.845-1.027-5.636-5.822,1.567-8.435-1.339-2.952-7.745-.758-9.593,3.574-1.2,5.336.917,6.655,3.254,9.825,2.235,5.59,3.374,2.538,8.788S38.468,49.786,36.9,49.6c-1.307-.158-5.943-.767-8.013.625a1.161,1.161,0,0,0-.006,1.886,1.873,1.873,0,0,0,1.344.485c.858-.188.169-1.6,10.295-1.192a12.683,12.683,0,0,0,3.541-.361C44.521,50.926,45,50.793,45.447,50.643Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37,18.913s4.444,4.663-.856,9.678-11.576-4.843-9-6.252,1.748-.173,1.852,1.194,1.1,6.1,5.957,4.06c4.213-1.768,2.081-6.974.7-7.908a.738.738,0,0,1-.12-1.168C35.814,18.288,36.265,18.277,37,18.913Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M28.166,35.43s1.128-4.028,4.367-4.269,2.689.437,2.074.5-2.886-.225-4.186,1.343a7.365,7.365,0,0,0-1.748,2.818C28.027,37.285,28.053,35.722,28.166,35.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.709,31.686s-.268-2.868-2.248-3.043-.824-.053-.058.66S48.492,33.626,48.709,31.686Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M21.4,12.038s.955,1.894,4.246,3.6,6.911,4.1,5.659,11-8.584,7.73-12.722,3.731c0,0-.772-1.457,1.568-.224s6.211,2.057,7.985-1.817,1.143-6.974-1.857-9.117-6.068-2.751-7.538-5.775C18.743,13.434,20.854,11.991,21.4,12.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M11.558,24.773s.115-8.759,10.543-10.931c0,0,5.6-.714,6.3,5.506s2.966,8.036,5.49,9.468,4.944,4.927,1.494,9.665S17.5,42.742,17.5,32.725s-5.835.951-5.3,2.409,1.029,2.022,3.426,3.765,9.342,5.075,10.147,10.656c0,0-.309.584-2.192-.5s-.1-3.3-6.577-7.347-8.8-5.424-4.279-12.848,6.38-1.775,6.476-.37-.176,6.824,3.718,8.927S32.226,38.6,33.675,35.7s.368-4.253-2.429-5.63S25.9,23.608,26.174,19.848s-5.2-5.254-10.347-.455S14.358,32.225,14.985,33.9c.522,1.4,2.425,6.336,1.443,8.985a1.315,1.315,0,0,1-2.074.508,2.124,2.124,0,0,1-.891-1.35c-.021-.994,1.714-.611-1.427-11.647a14.412,14.412,0,0,1-.544-3.993C11.494,25.867,11.511,25.3,11.558,24.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M26.556,15.254s1.675.914,2.018,5.408a10.07,10.07,0,0,0,5.446,8.189,5.836,5.836,0,0,1,2.171,8.378s2.552-5.408-2.476-8.112-5.407-6.4-5.636-8.531S27.812,16.968,26.556,15.254Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M45.471,19.494a4.572,4.572,0,0,0-5.484-1.726s-1.117.66.355.559A5.571,5.571,0,0,1,45.115,19.7C46.639,21.221,45.674,19.748,45.471,19.494Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M35.163,35.541s1.218-1.828.3-3.352-.489-1.788.01-1.452a4.207,4.207,0,0,1,1.311,3.483c-.075,1.9-1.27,4.571-3.3,5.231S32.725,38.232,35.163,35.541Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M14.191,26.908s1.828-2.082,3.047-1.523a3.574,3.574,0,0,1,1.625,2.742c.05.508.2,2.793.3,3.351s-.609.407-.66-.609,0-4.57-1.422-4.824a2.7,2.7,0,0,0-2.691,1.168C14.039,27.721,13.988,27.213,14.191,26.908Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M54.312,30.125c2.623,11.669-9.125,27-21.656,23.438-11.5-3.271-22.844-7.978-22.844-19.938S20.1,9.5,32.062,9.5,52.437,21.781,54.312,30.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M43.562,13.813s-1.375-1.313-2.187.125.75,1.625,1.5,1.75c0,0-.875.875.312,1.25s2.938-.125,4.938,2.062,5.062,8.313,3.75,11.75,2.125,6.375,1.5,8.563-1.438,5.437-3,6.687-3.313,3.125-1.5,2.875c0,0,5.25-4.812,5.812-14.375a14.409,14.409,0,0,0-1.375-8.687,63.167,63.167,0,0,0-4.75-7.188C48.125,17.875,47.625,15.875,43.562,13.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M20.437,49.063s-1.5-1.313.188-2,2.875,1.5,2.875,2.187,1.375,1.688,3.937,2.313,2.75-.313,4.063.062,3.375,2.125,5.437,1.75,2.625.313,1.125.563S27.5,53.25,20.437,49.063Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 37.781,
    cy: 17.594,
    rx: 1.281,
    ry: 1.156
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M27.807,26.2a8.247,8.247,0,0,1-8.557,8.5A9.217,9.217,0,0,1,10.1,25.641c0-4.944,4.232-8.529,9.176-8.529S27.807,21.26,27.807,26.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 19.25,
    cy: 25.754,
    r: 7.938
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 19.25,
    cy: 26,
    r: 7.185
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 19.25,
    cy: 26.364,
    r: 6.409
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M12.579,30s3.631-7.98,9.162-11.569c0,0,.971-.3,1.731.929s-9.078,7.685-6.333,8.656,8.149-6.334,9.88-3.378c0,0,.549,1.309-1.731,3.209S20.6,32.96,20.474,33.635a12.244,12.244,0,0,1-1.857.085A37.879,37.879,0,0,1,24.739,26.8c1.773-1.224.676-2.027-1.6-.169s-7.178,4.223-7.39,1.478,4.054-6.418,4.983-7.051.38-1.014-.507-.211a26.066,26.066,0,0,0-7.009,10.049A4.563,4.563,0,0,1,12.579,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M12.579,30a39.8,39.8,0,0,1,5.067-7.825c2.646-2.871,4.025-3.913,4.729-3.688a4.534,4.534,0,0,0-.563-.253c-.31-.113-2.365,1.126-4.926,4.11a36.742,36.742,0,0,0-4.561,7.318Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M10.411,27.977a8.426,8.426,0,0,1,4.757-9.964,8.515,8.515,0,0,1,11.007,2.758s-4.645-5.883-11.007-2.589A8.853,8.853,0,0,0,10.411,27.977Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M21.968,10.612A8.248,8.248,0,0,1,33.62,13.73,9.218,9.218,0,0,1,30.391,26.2c-4.273,2.487-9.5.633-11.988-3.639S17.7,13.1,21.968,10.612Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 25.885,
    cy: 18.234,
    r: 7.938
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 26.098,
    cy: 18.11,
    r: 7.185
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 26.412,
    cy: 17.927,
    r: 6.409
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M32.915,21.861s-8.724.877-14.608-2.1a1.589,1.589,0,0,1-.069-1.964c.676-1.273,11.209,3.979,10.667,1.118s-9.573-3.855-7.89-6.839c0,0,.855-1.133,3.644-.118s6.773,1.48,7.421,1.249a12.28,12.28,0,0,1,1.008,1.563,37.833,37.833,0,0,1-9.065-1.807c-1.95-.916-2.091.436.661,1.472s7.261,4.079,4.995,5.642-7.586-.274-8.6-.758-1.067.182.072.544a26.056,26.056,0,0,0,12.211,1A4.508,4.508,0,0,1,32.915,21.861Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M32.915,21.861a39.818,39.818,0,0,1-9.312-.442c-3.813-.842-5.407-1.51-5.566-2.231a4.263,4.263,0,0,0,.064.614c.058.324,2.163,1.477,6.03,2.189a36.734,36.734,0,0,0,8.619.259Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M32.254,24.753a8.425,8.425,0,0,1-11,.9,8.512,8.512,0,0,1-3.154-10.9s-2.747,6.974,3.3,10.814A8.853,8.853,0,0,0,32.254,24.753Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M41.843,23.369A8.247,8.247,0,0,1,29.8,24.04a9.217,9.217,0,0,1-.819-12.852c3.284-3.695,8.829-3.564,12.525-.281S45.127,19.673,41.843,23.369Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 35.745,
    cy: 17.349,
    r: 7.938
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 35.582,
    cy: 17.533,
    r: 7.185
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 35.34,
    cy: 17.805,
    r: 6.409
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M27.935,16.1s8.015-3.554,14.534-2.563a1.587,1.587,0,0,1,.677,1.844c-.245,1.421-11.891-.284-10.484,2.265s10.3.677,9.63,4.037c0,0-.459,1.343-3.426,1.249s-6.9.706-7.44,1.127a12.164,12.164,0,0,1-1.445-1.171,37.908,37.908,0,0,1,9.176-1.11c2.139.263,1.851-1.066-1.087-1.192s-8.171-1.611-6.506-3.8,7.293-2.1,8.408-1.962.957-.505-.238-.494a26.07,26.07,0,0,0-11.915,2.857A4.562,4.562,0,0,1,27.935,16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M27.935,16.1a39.815,39.815,0,0,1,8.985-2.484c3.885-.389,5.608-.252,5.985.384a4.323,4.323,0,0,0-.253-.563c-.157-.29-2.515-.729-6.412-.2a36.649,36.649,0,0,0-8.27,2.443Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M27.661,13.141a8.425,8.425,0,0,1,10.174-4.29,8.512,8.512,0,0,1,6.4,9.372s.435-7.483-6.508-9.246A8.853,8.853,0,0,0,27.661,13.141Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M53.4,33.748a7.241,7.241,0,0,1-13.3-5.723c2.405-5.45,6.7-7.719,10.374-6.138S55.52,28.816,53.4,33.748Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 46.453,
    cy: 31.569,
    r: 5.635
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M41.433,25.574a13.4,13.4,0,0,1,10.9-2.364l.544.594s-5.248-1.259-12.1,2.868Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 46.406,
    cy: 31.5,
    r: 4.063
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M46.51,48.845a7.241,7.241,0,1,1-5.36-13.454c5.553-2.153,10.2-.72,11.675,3S51.5,46.858,46.51,48.845Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 43.139,
    cy: 42.394,
    r: 5.635
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M43.83,34.6a13.4,13.4,0,0,1,9.381,6.038l-.036.8s-2.821-4.6-10.583-6.528Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M37.668,53.016s-7.978-7.548-6.081-15.088,4.485-.095,2.844,1.027-1.025,4.161-.1,6,2.647,4.191,3.914,4.325S42.364,54.925,37.668,53.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M40.457,51.592S32.639,46.8,32.89,40.314s3.647-.85,2.5.349-.12,3.576.951,4.92,2.884,2.967,3.942,2.858S44.622,52.343,40.457,51.592Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M35.454,52.766s-6.066-5-3.711-9.194,3.833.309,2.325.823-1.281,2.316-.674,3.452,1.848,2.632,2.915,2.812S39.271,54.248,35.454,52.766Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M40.546,52.448s-6.527-6.523-4.759-12.811,3.768.023,2.364.927-.957,3.471-.224,5.038,2.126,3.58,3.188,3.722S44.445,54.159,40.546,52.448Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M21.5,31.337s.7-1.194-1.172-.82-1.168,1.107-1.168,1.107.44-1.724-.707-.733a3.894,3.894,0,0,0-1.113,2.74s-.573-2.09-2.082-.445a1.9,1.9,0,0,0-.054,2.88s-.449,1.12-.936,1.15-.005,1.324-.005,1.324L14.051,39.7s.211,1.395,1.275,1.562-1.876.373-1.773,1.115,1.732,1.044,1.732,1.044-1.526.439-.048,1.556a4.316,4.316,0,0,0,3.375.627l-.755.823s1.223,1.191,1.637.906.664.966,1.34,1.213,1.5-.926,1.5-.926,1.529,1.488,2.482,1.544,1.132-1.321,1.132-1.321.524.184,1.373-.5,1.907.5,2.194-1.565-1.093-1.12-1.093-1.12,1.892.38,1.806-.553-1.74-1.525-1.74-1.525S30.662,42.7,30,41.131a2.4,2.4,0,0,0-1.876-1.637s.162-.64.264-1.161-1.413-1.086-1.413-1.086.357.529-.313-.829a3.855,3.855,0,0,0-2.277-1.778s.914-1.034.346-1.861-2.349-.317-2.349-.317S24.557,30.459,21.5,31.337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M19.707,32.242a.62.62,0,0,1-.442.759h0a.621.621,0,0,1-.759-.443l-.474-1.8A.62.62,0,0,1,18.475,30h0a.621.621,0,0,1,.759.442Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M21.193,32.648c-.093.156-.407.14-.7-.036h0c-.294-.176-.458-.445-.365-.6l.506-.848c.093-.156.408-.14.7.036h0c.3.176.458.445.365.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M19.38,32.46a.557.557,0,0,1,.18.744h0c-.13.318-.42.5-.649.406L17.668,33.1a.555.555,0,0,1-.18-.744h0c.129-.318.42-.5.649-.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M15.134,38.984a.622.622,0,0,1,.268.837h0a.62.62,0,0,1-.836.268l-1.657-.851a.621.621,0,0,1-.269-.836h0a.621.621,0,0,1,.836-.269Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M16.428,38.15c.054.174-.168.4-.5.5h0c-.327.1-.636.044-.69-.13l-.293-.942c-.054-.174.168-.4.5-.5h0c.328-.1.637-.043.691.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M15.077,39.374c.223-.108.524.055.674.363h0a.555.555,0,0,1-.132.754l-1.208.586c-.222.108-.524-.054-.673-.363h0a.556.556,0,0,1,.131-.754Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M19.226,41.711a.621.621,0,0,1-.443.759h0a.622.622,0,0,1-.759-.443l-.473-1.8a.62.62,0,0,1,.442-.758h0a.622.622,0,0,1,.759.442Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M20.711,42.117c-.093.156-.407.14-.7-.036h0c-.294-.176-.457-.445-.364-.6l.506-.847c.093-.156.407-.14.7.035h0c.295.176.458.445.365.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M18.9,41.93a.555.555,0,0,1,.18.744h0c-.13.317-.42.5-.649.406l-1.243-.508a.556.556,0,0,1-.18-.744h0c.13-.317.42-.5.649-.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M18.463,35.459a.622.622,0,0,1-.442.759h0a.621.621,0,0,1-.759-.443l-.474-1.8a.622.622,0,0,1,.443-.759h0a.62.62,0,0,1,.758.443Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M19.949,35.865c-.093.156-.408.14-.7-.036h0c-.295-.176-.458-.445-.365-.6l.506-.848c.093-.156.407-.14.7.036h0c.3.176.458.445.365.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M18.136,35.677a.557.557,0,0,1,.18.744h0c-.13.318-.421.5-.649.406l-1.244-.507a.556.556,0,0,1-.179-.744h0c.129-.318.42-.5.649-.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M26.392,36.375a.622.622,0,0,1-.873.1h0a.62.62,0,0,1-.1-.872l1.152-1.464a.621.621,0,0,1,.872-.1h0a.621.621,0,0,1,.1.872Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M26.963,37.8c-.181.02-.357-.24-.394-.581h0c-.038-.341.079-.634.259-.653l.982-.107c.18-.02.357.24.394.581h0c.037.341-.079.634-.259.653Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M26.02,36.245c.064.239-.154.5-.485.592h0a.556.556,0,0,1-.715-.274l-.345-1.3c-.063-.238.154-.5.486-.591h0a.556.556,0,0,1,.715.273Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M24.229,41.829a.621.621,0,0,1-.859.184h0a.621.621,0,0,1-.183-.859L24.2,39.59a.621.621,0,0,1,.859-.183h0a.62.62,0,0,1,.184.858Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M24.93,43.2c-.178.036-.378-.207-.446-.543h0c-.069-.336.02-.638.2-.675l.968-.2c.178-.036.378.207.446.543h0c.069.336-.02.638-.2.674Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M23.847,41.734c.086.232-.106.516-.428.635h0a.558.558,0,0,1-.738-.207l-.462-1.26c-.085-.232.107-.516.429-.634h0a.556.556,0,0,1,.737.206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M25.739,46.751a.621.621,0,0,1-.442.759h0a.621.621,0,0,1-.759-.443l-.474-1.8a.621.621,0,0,1,.443-.758h0a.622.622,0,0,1,.759.442Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M27.225,47.157c-.093.156-.407.14-.7-.036h0c-.295-.176-.458-.445-.365-.6l.506-.847c.093-.156.408-.14.7.035h0c.3.176.458.445.365.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M25.412,46.97a.556.556,0,0,1,.18.744h0c-.13.317-.42.5-.649.406L23.7,47.612a.555.555,0,0,1-.18-.744h0c.129-.317.42-.5.649-.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M20.772,46.083a.62.62,0,0,1-.868.133h0a.62.62,0,0,1-.133-.868l1.1-1.5a.621.621,0,0,1,.868-.133h0a.621.621,0,0,1,.133.868Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M21.392,47.493c-.18.026-.366-.229-.414-.568h0c-.049-.34.057-.636.237-.662l.977-.14c.18-.026.366.228.414.568h0c.049.339-.057.636-.237.661Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M20.4,45.966c.072.236-.136.509-.465.608h0a.556.556,0,0,1-.724-.249l-.388-1.285c-.071-.237.137-.509.465-.608h0a.555.555,0,0,1,.724.249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M15.575,44.389a.621.621,0,0,1,.665.574h0a.621.621,0,0,1-.574.665l-1.858.136a.621.621,0,0,1-.665-.574h0a.62.62,0,0,1,.574-.664Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M16.246,43c.136.12.063.426-.164.683h0c-.227.258-.521.369-.657.249l-.741-.652c-.137-.12-.063-.427.163-.684h0c.227-.257.521-.369.658-.249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M15.73,44.751a.556.556,0,0,1,.764-.041h0a.556.556,0,0,1,.281.712l-.726,1.13a.556.556,0,0,1-.764.041h0A.557.557,0,0,1,15,45.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M28.383,40.493a.622.622,0,0,1-.878.025h0a.622.622,0,0,1-.025-.878l1.28-1.354a.62.62,0,0,1,.878-.025h0a.622.622,0,0,1,.025.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M28.824,41.968c-.182,0-.334-.271-.341-.614h0c-.006-.343.136-.624.318-.627l.987-.019c.181,0,.334.272.34.615h0c.007.343-.135.624-.317.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M28.025,40.33c.042.244-.2.488-.537.546h0c-.338.058-.646-.093-.687-.336l-.227-1.324c-.041-.244.2-.488.537-.546h0c.338-.057.646.093.688.337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M29.05,44.591a.621.621,0,0,1-.443.759h0a.622.622,0,0,1-.759-.443l-.473-1.8a.62.62,0,0,1,.442-.758h0a.622.622,0,0,1,.759.442Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M30.535,45c-.093.156-.407.14-.7-.036h0c-.294-.176-.458-.445-.364-.6l.506-.847c.093-.156.407-.14.7.035h0c.3.176.458.445.365.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M28.722,44.81a.555.555,0,0,1,.18.744h0c-.13.317-.42.5-.649.406l-1.243-.508a.555.555,0,0,1-.18-.744h0c.13-.317.42-.5.649-.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M21.026,38.845a.62.62,0,0,1-.809.339h0a.621.621,0,0,1-.34-.81l.705-1.724a.622.622,0,0,1,.81-.34h0a.621.621,0,0,1,.34.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M21.969,40.062c-.168.069-.409-.133-.539-.45h0c-.13-.318-.1-.631.07-.7l.914-.373c.168-.068.41.134.539.451h0c.13.318.1.631-.07.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M20.634,38.822a.558.558,0,0,1-.3.7h0a.557.557,0,0,1-.763-.067l-.688-1.153c-.127-.212.01-.526.3-.7h0a.557.557,0,0,1,.763.066Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M22.568,34.658a.621.621,0,0,1-.877-.047h0a.621.621,0,0,1,.047-.877l1.386-1.246a.621.621,0,0,1,.877.047h0a.621.621,0,0,1-.047.877Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M22.887,36.164c-.181-.011-.311-.3-.289-.64h0c.022-.343.186-.611.367-.6l.986.062c.181.011.311.3.289.64h0c-.022.343-.186.611-.368.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M22.225,34.466c.021.246-.238.47-.58.5h0c-.342.03-.636-.145-.658-.391l-.117-1.338c-.022-.246.238-.47.579-.5h0c.342-.03.637.145.658.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M26.349,53.615s-.663,1.071,1.049.769,1.085-.983,1.085-.983-.435,1.558.628.681a3.544,3.544,0,0,0,1.068-2.469s.478,1.912,1.884.446a1.726,1.726,0,0,0,.107-2.617s.43-1.01.874-1.027.031-1.2.031-1.2l.22-1.054s-.163-1.272-1.127-1.445,1.712-.3,1.634-.978-1.554-.985-1.554-.985,1.4-.368.075-1.414a3.931,3.931,0,0,0-3.056-.638l.7-.733s-1.088-1.107-1.47-.857-.584-.892-1.194-1.129-1.379.812-1.379.812-1.361-1.384-2.226-1.455-1.056,1.179-1.056,1.179-.472-.179-1.259.427-1.724-.5-2.026,1.378.971,1.041.971,1.041-1.712-.384-1.653.466,1.551,1.422,1.551,1.422-1.977-.15-1.4,1.289A2.179,2.179,0,0,0,20.5,46.064s-.16.58-.264,1.051S21.5,48.131,21.5,48.131s-.313-.488.268.76A3.5,3.5,0,0,0,23.8,50.553s-.853.922-.352,1.686,2.129.335,2.129.335S23.556,54.351,26.349,53.615Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M28,52.828a.566.566,0,0,1,.418-.681h0a.566.566,0,0,1,.681.418l.394,1.648a.565.565,0,0,1-.417.681h0a.566.566,0,0,1-.681-.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M26.659,52.429c.088-.14.373-.119.637.047h0c.265.166.408.414.32.554l-.477.76c-.088.14-.373.119-.638-.046h0c-.264-.166-.407-.414-.319-.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M28.3,52.636a.5.5,0,0,1-.149-.68h0c.124-.286.392-.446.6-.356l1.12.486a.505.505,0,0,1,.149.68h0c-.124.287-.392.446-.6.356Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M32.3,46.79a.565.565,0,0,1-.227-.766h0a.564.564,0,0,1,.765-.227l1.49.807a.565.565,0,0,1,.227.766h0a.564.564,0,0,1-.765.227Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M31.1,47.523c-.045-.159.161-.358.461-.444h0c.3-.086.58-.026.625.133l.248.863c.045.159-.161.357-.461.443h0c-.3.086-.58.027-.625-.132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M32.355,46.437c-.2.094-.475-.06-.6-.344h0a.505.505,0,0,1,.135-.683l1.11-.508c.2-.094.475.06.605.344h0a.505.505,0,0,1-.135.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M28.631,44.228a.565.565,0,0,1,.417-.681h0a.566.566,0,0,1,.681.418l.395,1.648a.566.566,0,0,1-.418.681h0a.566.566,0,0,1-.681-.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M27.288,43.829c.088-.14.373-.119.637.047h0c.265.166.408.414.32.554l-.477.76c-.088.14-.373.119-.638-.046h0c-.264-.166-.407-.414-.319-.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M28.933,44.036a.5.5,0,0,1-.149-.68h0c.124-.286.392-.445.6-.356l1.121.486a.507.507,0,0,1,.148.681h0c-.124.286-.392.445-.6.356Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M29.2,49.928a.565.565,0,0,1,.417-.681h0a.565.565,0,0,1,.681.418l.395,1.648a.566.566,0,0,1-.418.681h0a.566.566,0,0,1-.681-.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M27.855,49.53c.088-.14.373-.12.638.046h0c.264.166.407.414.319.554l-.477.76c-.088.14-.373.119-.637-.046h0c-.265-.166-.408-.414-.32-.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M29.5,49.736a.506.506,0,0,1-.149-.68h0c.125-.286.392-.445.6-.356l1.12.487a.506.506,0,0,1,.148.68h0c-.124.286-.392.445-.6.356Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M22.007,48.936a.566.566,0,0,1,.8-.077h0a.565.565,0,0,1,.076.8L21.8,50.962a.565.565,0,0,1-.795.077h0a.565.565,0,0,1-.077-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M21.517,47.624c.164-.014.32.226.347.537h0c.027.311-.085.574-.25.589l-.894.077c-.165.014-.32-.226-.347-.537h0c-.027-.31.085-.574.249-.588Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M22.343,49.061c-.053-.218.15-.455.453-.528h0a.507.507,0,0,1,.645.263l.286,1.187c.053.218-.15.455-.453.528h0a.505.505,0,0,1-.645-.263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M24.083,44.02a.566.566,0,0,1,.785-.15h0a.566.566,0,0,1,.15.785l-.952,1.4a.566.566,0,0,1-.785.15h0a.566.566,0,0,1-.15-.785Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M23.474,42.759c.162-.029.339.2.395.5h0c.055.307-.032.579-.194.609l-.884.159c-.162.03-.339-.2-.395-.5h0c-.055-.307.032-.58.194-.609Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M24.429,44.114c-.073-.213.107-.467.4-.568h0a.507.507,0,0,1,.667.2l.395,1.156c.072.212-.108.467-.4.568h0a.506.506,0,0,1-.666-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M22.81,39.514a.565.565,0,0,1,.418-.681h0a.565.565,0,0,1,.68.418L24.3,40.9a.566.566,0,0,1-.418.681h0a.566.566,0,0,1-.681-.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M21.467,39.116c.088-.14.373-.12.638.046h0c.264.166.407.414.319.554l-.477.76c-.088.14-.373.12-.637-.046h0c-.265-.166-.408-.414-.32-.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M23.112,39.322a.506.506,0,0,1-.149-.68h0c.125-.286.392-.445.6-.356l1.12.487a.506.506,0,0,1,.148.68h0c-.124.286-.392.445-.6.356Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M27.313,40.222a.565.565,0,0,1,.792-.1h0a.565.565,0,0,1,.1.792l-1.032,1.344a.565.565,0,0,1-.792.1h0a.565.565,0,0,1-.1-.792Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M26.778,38.928c.164-.02.327.215.365.525h0c.037.309-.066.576-.23.6l-.891.108c-.164.02-.327-.215-.365-.525h0c-.037-.309.065-.576.229-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M27.652,40.336c-.06-.216.135-.46.435-.543h0a.5.5,0,0,1,.653.241l.327,1.176c.06.217-.134.46-.435.544h0a.506.506,0,0,1-.653-.241Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M32,41.867a.565.565,0,0,1-.593-.535h0a.564.564,0,0,1,.535-.593l1.692-.087a.565.565,0,0,1,.593.536h0a.564.564,0,0,1-.535.592Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M31.366,43.114c-.121-.112-.049-.389.163-.618h0c.211-.23.481-.325.6-.213l.661.608c.121.112.049.389-.163.618h0c-.211.23-.481.325-.6.213Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M31.87,41.535a.507.507,0,0,1-.7.022h0a.507.507,0,0,1-.24-.654l.683-1.012a.505.505,0,0,1,.695-.022h0a.506.506,0,0,1,.241.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M20.28,45.151a.564.564,0,0,1,.8-.005h0a.564.564,0,0,1,0,.8l-1.19,1.206a.566.566,0,0,1-.8,0h0a.565.565,0,0,1-.005-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M19.909,43.8c.165,0,.3.254.3.566h0c0,.311-.136.564-.3.563l-.9,0c-.165,0-.3-.254-.3-.566h0c0-.312.136-.564.3-.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M20.6,45.306c-.033-.222.191-.439.5-.485h0c.309-.046.586.1.619.32l.179,1.208c.033.222-.191.439-.5.485h0c-.309.046-.586-.1-.619-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M19.756,41.411a.565.565,0,0,1,.418-.68h0a.564.564,0,0,1,.681.417l.394,1.648a.564.564,0,0,1-.417.681h0a.564.564,0,0,1-.681-.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M18.414,41.013c.088-.14.373-.119.637.046h0c.265.166.408.414.32.554l-.477.76c-.088.14-.374.12-.638-.046h0c-.264-.166-.407-.414-.319-.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M20.058,41.22a.507.507,0,0,1-.148-.681h0c.124-.286.392-.445.6-.356l1.12.487a.5.5,0,0,1,.149.68h0c-.124.286-.392.445-.6.356Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M26.935,46.8a.565.565,0,0,1,.744-.292h0a.564.564,0,0,1,.292.743L27.3,48.8a.564.564,0,0,1-.743.292h0a.565.565,0,0,1-.293-.743Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M26.1,45.672c.154-.059.37.129.481.421h0c.111.291.076.575-.078.634l-.839.321c-.154.059-.369-.13-.481-.421h0c-.111-.291-.076-.575.078-.634Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M27.292,46.827c-.111-.2.019-.479.291-.633h0a.505.505,0,0,1,.692.076l.6,1.062c.111.2-.019.479-.291.632h0a.505.505,0,0,1-.692-.075Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M25.449,50.574a.565.565,0,0,1,.8.06h0a.564.564,0,0,1-.06.8l-1.285,1.1a.563.563,0,0,1-.8-.06h0a.564.564,0,0,1,.06-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M25.189,49.2c.165.014.277.277.251.588h0c-.027.311-.182.551-.347.537l-.894-.076c-.165-.014-.277-.277-.25-.588h0c.026-.311.181-.552.346-.538Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M25.758,50.755c-.015-.224.225-.423.537-.443h0c.311-.02.575.145.59.369l.08,1.219c.014.224-.226.422-.537.443h0c-.312.02-.576-.145-.591-.369Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M31.264,28.433l-.9.6a.812.812,0,0,0,.09,1.4l.025.013a.813.813,0,0,0,1.174-.775l-.062-1.08A.211.211,0,0,0,31.264,28.433Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M30.7,32.131l-.9.6a.813.813,0,0,0,.09,1.4l.026.013a.812.812,0,0,0,1.173-.774l-.062-1.081A.21.21,0,0,0,30.7,32.131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M35.594,31.132l-.287,1.043a.813.813,0,0,0,.985,1l.028-.007a.812.812,0,0,0,.381-1.353l-.753-.777A.21.21,0,0,0,35.594,31.132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M29.121,29.1l-.481.97a.813.813,0,0,0,.776,1.172l.028,0a.812.812,0,0,0,.633-1.255l-.591-.907A.211.211,0,0,0,29.121,29.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M32.535,27.977l-.749-.781a.812.812,0,0,0-1.366.331l-.008.027a.813.813,0,0,0,.966,1.022l1.053-.248A.211.211,0,0,0,32.535,27.977Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M33.209,34.2l1.068-.178a.813.813,0,0,0,.5-1.315l-.018-.022a.813.813,0,0,0-1.388.221l-.39,1.01A.211.211,0,0,0,33.209,34.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M34.3,28.733l.48.97a.812.812,0,0,0,1.4.095l.016-.023a.813.813,0,0,0-.614-1.265L34.5,28.43A.211.211,0,0,0,34.3,28.733Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M32.791,30l-.9.6a.812.812,0,0,0,.09,1.4l.025.013a.813.813,0,0,0,1.174-.775l-.062-1.08A.211.211,0,0,0,32.791,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M33.646,26.718l-.9.6a.812.812,0,0,0,.09,1.4l.025.012a.813.813,0,0,0,1.174-.774l-.062-1.081A.212.212,0,0,0,33.646,26.718Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 43,
    cy: 42.563,
    r: 4.063
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIcon);
export default __webpack_public_path__ + "static/media/FoodIcon.9bf1038601e417d5f6661bf4f5980333.svg";
export { ForwardRef as ReactComponent };